const GRAY = '#6b7280';
const BLUE = '#38bdf8';
const GREEN = '#10b981';
const RED = '#ef4444';

const clampProgress = value => Math.min(100, Math.max(0, Math.round(value)));

export function getWorkoutProgressPresentation({ status, progress, hasWorkoutProgress = false } = {}) {
  const color = status === 'done' ? GREEN
    : status === 'active' || status === 'partial' || hasWorkoutProgress ? BLUE
      : status === 'missed' ? RED
        : GRAY;
  return {
    progress: progress == null || (typeof progress === 'string' && !progress.trim()) || !Number.isFinite(Number(progress))
      ? null
      : clampProgress(Number(progress)),
    color,
  };
}